<!-- 热门新闻列表 -->
<template>
  <div class="news-list-wrap" v-if="newsList.length >= 3">
    <div class="title">
      更多优质资讯
    </div>
      <div
        class="news-item act-log"
        v-for="(item, index) in newsList"
        :key="index"
        :class="{ 'click-style': isClickArr[index] }"
        :id="'id' + item.adgroup_id"
        :data-id="'id' + item.adgroup_id"
        :data-index="index"
        @click="goDetail(item, index)"
      >
        <div class="news-left">
          <div class="news-item-title">{{item.showTitle}}</div>
          <div class="left-bottom">
            <span class="news-item-desc">{{ noticeLabelName(item) }}</span>
            <span class="news-item-desc time">{{dateHandle(item.start_time)}}</span>
          </div>
        </div>
        <div
          class="news-right"
          :style="{ backgroundImage: `url(${item.showImage})` }"
        ></div>
      </div>
  </div>
</template>

<script>
import {
  native, log, util
} from '@ali/amap-lib';
import dayjs from 'dayjs';
import viewPortLog from '../../../../common/js/view-port-log';
import service from '../../../../common/js/service';

export default {
  name: 'HotNewsList',
  data() {
    return {
      isClickArr: [],
      clickFlag: false,
    };
  },
  props: {
    newsList: {
      type: Array,
      default: () => [],
    },
    categoryList: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    setTimeout(() => {
      this.initLogPv();
    }, 2000);
  },
  methods: {
    /**
     * 获取一级标签名
     */
    noticeLabelName(curInfo) {
      const curTypeArr = this.categoryList.filter(
        (item) => item.contentCategoryId === curInfo.content_category
      );
      return curTypeArr.length ? curTypeArr[0].categoryName : '热门推荐';
    },
    async goDetail(item, index) {
      const { action_config: actConfig, adgroup_id: adGroupId } = item;
      const { h5, schema, shell_url: shellUrl } = actConfig;
      const jumpUrl = shellUrl || h5 || schema;
      if (!jumpUrl) return false;
      if (this.clickFlag) return false;
      this.clickFlag = true;
      // 处理埋点和存储
      this.logItem('article_click', item, index);
      if (!this.isClickArr[index]) {
        const storageResult = await service.getLocalStorage().catch(() => false);
        try {
          const articleArr = (storageResult && JSON.parse(storageResult)) || [];
          if (Array.isArray(articleArr)) {
            const singleArticleArr = Array.from(new Set(articleArr));
            const articleIndex = singleArticleArr.findIndex((data) => data.value === adGroupId);
            if (articleIndex === -1) {
              singleArticleArr.push({
                from: util.getUrlParam('from') || '',
                time: Math.floor(Date.now() / 1000),
                value: adGroupId,
              });
              await service.setLocalStorage(singleArticleArr);
            }
          }
        } catch (e) {
          console.log(e);
        }
      }
      this.$set(this.isClickArr, index, true);
      // 跳转
      console.log('推荐新闻跳转链接：', jumpUrl);
      this.timer = setTimeout(() => {
        this.clickFlag = false;
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }
      }, 1000);
      native.loadSchema(jumpUrl);
    },
    // 曝光埋点
    setViewPortLog() {
      const wrapper = window;
      // 参数
      const viewPortLogOption = {
        targetClass: '.act-log', // 目标元素css选择器
        containerDom: wrapper, // 目标元素所在容器的Dom
        cb: (el) => {
          const curIndex = el.getAttribute('data-index') || '';
          if (!curIndex) return false;
          const item = this.newsList?.[curIndex];
          this.logItem('article_pv', item, curIndex);
        }, // 目标元素曝光后执行的回调函数
        option: {
          threshold: 0.5,
          once: true,
        }
      };
      this.viewPortLog = viewPortLog(viewPortLogOption);
    },
    initLogPv() {
      this.$nextTick(() => {
        if (!this.viewPortLog) {
          this.setViewPortLog();
        } else {
          this.viewPortLog.updateObserve();
        }
      });
    },
    logItem(clickName, item, type) {
      log.log(clickName, {
        from: util.getUrlParam('from') || '',
        external_info: item?.external_info,
        type: +type + 1,
      });
    },
    dateHandle(time) {
      if (String(time).length === 13) {
        time = parseInt(time / 1000, 10);
      }
      return dayjs.unix(time).format('YYYY年MM月DD日');
    }
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.news-list-wrap {
  margin: 0.1rem auto 0.3rem;
  width: 6.7rem;
  .title {
    position: relative;
    font-weight: bold;
    font-size: 0.36rem;
    color: #000;
    padding-left: 0.12rem;
    .close {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 0.8rem;
      height: 0.8rem;
      border: 1px solid red;
    }
    &:before {
      position: absolute;
      width: 0.04rem;
      height: 0.26rem;
      content: '';
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      background: #4eb7ff;
    }
  }

  .news-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding-top: 0.32rem;
    padding-bottom: 0.24rem;
    height: 2.22rem;
    border-bottom: 1px solid #eae9e9;
    &.click-style {
      opacity: 0.5;
    }
    .news-left {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;
      .news-item-title {
        font-size: 0.28rem;
        color: #191919;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .news-item-desc {
        font-size: 0.24rem;
        color: #999;
      }
      .time {
        margin-left: 0.24rem;
      }
    }
    .news-right {
      margin-left: 0.34rem;
      width: 2.26rem;
      height: 1.68rem;
      background-color: #f7f8f9;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center center;
      border-radius: 0.16rem;
    }
  }
}
/*适配iPhone X ,iphone Xr ,iphone XS*/
@media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3),
  only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2),
  only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3),
  only screen and (device-width: 360px) and (device-height: 780px) and (-webkit-device-pixel-ratio: 3),
  /* 适配iPhone 12 MINI */ only screen and (device-width: 390px) and (device-height: 844px) and (-webkit-device-pixel-ratio: 3),
  /* 适配iPhone 12&& 12pro */ only screen and (device-width: 428px) and (device-height: 926px) and (-webkit-device-pixel-ratio: 3) {
  /* 适配iPhone 12pro MAX */
  .ios .news-list-bg {
    padding-bottom: 0.68rem;
  }
}
</style>
